declare namespace $ {

	type $mol_locale_select__dictionary_bog_dobro_app_settings_1 = $mol_type_enforce<
		({ 
			'ru': string,
			'en': string,
			'de': string,
		}) 
		,
		ReturnType< $mol_locale_select['dictionary'] >
	>
	type $mol_labeler__title_bog_dobro_app_settings_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_dobro_app_settings_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_button_major__title_bog_dobro_app_settings_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_dobro_app_settings_5 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_settings['install'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_labeler__title_bog_dobro_app_settings_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_dobro_app_settings_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	export class $bog_dobro_app_settings extends $mol_page {
		Language_select( ): $mol_locale_select
		Language_labeler( ): $mol_labeler
		install( next?: any ): any
		Install_button( ): $mol_button_major
		Install_labeler( ): $mol_labeler
		title( ): string
		body( ): readonly(any)[]
		install_ios_instruction( ): string
		install_android_instruction( ): string
		install_desktop_instruction( ): string
		install_unsupported_browser( ): string
		install_already_installed( ): string
	}
	
}

//# sourceMappingURL=settings.view.tree.d.ts.map